exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".clientContractsItem-ecd37{font-weight:600}.clientContractsItem-ecd37 .field-fbd89{font-weight:400;color:#595959}", ""]);

// Exports
exports.locals = {
	"clientContractsItem": "clientContractsItem-ecd37",
	"field": "field-fbd89"
};